import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import axios from "axios";
import {withSnackbar} from 'notistack';
import {bffUrl} from '../config'
import ReactTable from 'react-table'
import 'react-table/react-table.css'
import './Ingestion.css'
import IngestionService from "../Services/IngestionStatusService";
import {DateTime} from "luxon";
import moment from "moment-timezone";
import _ from "lodash";
import showSnackBar from "../Utilities/SnackbarHelper";
import {ERROR} from "../constants";
import Tooltip from "@material-ui/core/Tooltip";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import SearchIcon from "@material-ui/icons/Search"
import Paper from "@material-ui/core/Paper";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import Button from "@material-ui/core/Button";
import Icon from "@material-ui/core/Icon";

const styles = theme => ({
    container: {
        position: 'relative',
    },
    toolsContainer: {
        width: '95vw'
    }

});

let customFilterString = (filter, row) => {
    const id = filter.pivotId || filter.id;
    if (row[id] !== null && typeof row[id] === "string") {
        return (row[id] !== undefined
            ? String(row[id].toLowerCase()).includes(filter.value.toLowerCase())
            : true);
    }
};


class StatusTable extends Component {

    constructor(props) {

        super(props);

        this.filterAll = this.filterAll.bind(this);


        let columnDefs = [
            {
                Header: "Received At", accessor: "createdAt", width: 170,
                Footer: data => {
                    return (
                        <span>
                          <strong>Total:</strong>
                            {this.state && this.state.ingestionData && this.state.ingestionData.length > 0 &&
                            <>{this.state.ingestionData.length}</>
                            }

                        </span>
                    )
                }
            },
            {
                Header: "Series Title", accessor: "seriesTitle",
                width: 150,
            },
            {
                Header: "Series No", accessor: "seriesNumber",
                width: 50,
            },
            {
                Header: "Episode Title", accessor: "episodeTitle",
                width: 150,
            },
            {
                Header: "Episode No", accessor: "episodeNumber",
                width: 50,
            },
            {
                Header: "Status", accessor: "status",
                Cell: row => {
                    return (<span
                        title={`Updated at ${row.original.updatedAt}; Retry Count : ${row.original.retryCount}`}>{row.value}</span>)
                },
                width: 200,
            },
            {
                Header: "Message",
                accessor: "message",
                width: 250
            },
            {
                Header: "CID", accessor: "cid",
                width: 120,
            },
            {
                Header: "Video File Received", accessor: "isVideoFileReceived",
                width: 50,
                Cell: props => <span>{((props.value) === "Yes" ?
                    <Typography color={'primary'}>{props.value}</Typography> :
                    <Typography color={'error'}><b>{props.value}</b></Typography>)}</span>,
            },
            {
                Header: "Metadata File Received", accessor: "isMetadataFileReceived",
                width: 50,
                Cell: props => <span>{((props.value) === "Yes" ?
                    <Typography color={'primary'}>{props.value}</Typography> :
                    <Typography color={'error'}><b>{props.value}</b></Typography>)}</span>,
            },
            {
                Header: "Video File", accessor: "videoFileName",
                width: 150,
            },
            {
                Header: "Metadata File", accessor: "metadataFileName",
                width: 150,
            },
            {
                Header: "SCID", accessor: "scid",
                width: 100,
            },
            {
                Header: "Retry Count", accessor: "retryCount",
                width: 50,
            },
            {
                // NOTE - this is a "filter all" DUMMY column
                // you can't HIDE it because then it wont FILTER
                // but it has a size of ZERO with no RESIZE and the
                // FILTER component is NULL (it adds a little to the front)
                Header: "All",
                id: 'all',
                width: 0,
                resizable: false,
                sortable: false,
                filter: null,
                getProps: () => ({style: {padding: "0px"}}),
                getHeaderProps: () => ({style: {padding: 0}}),
                filterMethod: (filter, rows) => {
                    // using match-sorter
                    // it will take the content entered into the "filter"
                    // and search for it in EITHER the firstName or lastName

                    let filteredRows = _.filter(rows, (row) => {
                        let match = false;

                        Object.entries(row).forEach(([key, value]) => {
                            if (value && value !== "") {
                                if (String(value.toString().toLowerCase()).includes(filter.value.toLowerCase())) {
                                    match = true;
                                }
                            }
                        });


                        return match;
                    })

                    return filteredRows;
                },
                filterAll: true,
            },

        ];

        this.state = {
            cid: '',
            refreshMinutes: 10,
            ingestionData: [],
            loading: true,
            columnDefs: columnDefs,
            INGESTION_TOOL: true
        };

    }

    onFilteredChange(filtered) {
        if (filtered && filtered.length > 1 && this.state.filterAll && this.state.filterAll.length) {
            // NOTE: this removes any FILTER ALL filter
            const filterAll = '';
            this.setState({filtered: filtered.filter((item) => item.id != 'all'), filterAll})
        } else
            this.setState({filtered});
    }

    filterAll(e) {
        const {value} = e.target;
        const filterAll = value;
        const filtered = [{id: 'all', value: filterAll}];
        // NOTE: this completely clears any COLUMN filters
        this.setState({filterAll, filtered});
    }


    handleChange = element => event => {
        this.setState({
            [element]: event.target.value,
        }, function () {

        });
    };

    componentDidMount() {
        this.getIngestionData();

        let self = this;

        setInterval(() => {
            // refresh every refreshMinute
            self.getIngestionData();
        }, this.state.refreshMinutes * 60 * 1000);

        if (sessionStorage.INGESTION_TOOL == "true") {
            this.setState({INGESTION_TOOL: true});
        }

        window.addEventListener('storage', (event) => {
            console.log(event);
            if (event.key && event.key === "INGESTION_TOOL") {
                if (event.newValue && event.newValue == "true") {
                    self.setState({INGESTION_TOOL: true})
                } else if (event.newValue && event.newValue == "false") {
                    self.setState({INGESTION_TOOL: false})
                }
            }
        })
    }

    snackBarCloseHandler = () => {
        this.setState({
            snackBarOpen: false
        })
    };

    getIngestionData = () => {

        let self = this;

        self.setState({loading: true});
        IngestionService.getStatus("discovery")
            .then(response => {

                self.setState({loading: false});
                if (response.data) {

                    let ingestionResponse = response.data;

                    if (ingestionResponse.data) {

                        let ingestionData = ingestionResponse.data;

                        _.forEach((ingestionData), (ingestionRecord) => {
                            ingestionRecord.createdAt = moment(ingestionRecord.createdAt).local().format("DD-MM-YYYY, hh:mm A");
                            ingestionRecord.updatedAt = moment(ingestionRecord.updatedAt).local().format("DD-MM-YYYY, hh:mm A");
                            ingestionRecord.isVideoFileReceived = ingestionRecord.isVideoFileReceived ? "Yes" : "No";
                            ingestionRecord.isMetadataFileReceived = ingestionRecord.isMetadataFileReceived ? "Yes" : "No";
                        })
                        this.setState({
                            ingestionData: ingestionResponse.data
                        }, () => {

                        })
                    } else {
                        showSnackBar("Could not get ingestion status data", ERROR, self)
                    }


                } else {
                    showSnackBar("Could not get ingestion status data", ERROR, self)
                }
            })
            .catch(err => {
                self.setState({loading: false});
                showSnackBar("Could not get ingestion status data", ERROR, self)
            });

    };


    render() {
        const {classes, theme} = this.props;
        const flex = {flexGrow: 1};

        let self = this;

        let timezone = moment.tz.guess();

        return (
            <React.Fragment>

                {this.state.INGESTION_TOOL === true &&
                <React.Fragment>


                    <Grid container className={classes.toolsContainer}
                          direction="row"
                          justify="flex-start"
                          alignItems="center" spacing={0}>
                        <Grid item xs={4}>
                            <TextField
                                fullWidth variant={"outlined"}
                                value={this.state.filterAll} onChange={this.filterAll} label="Filter All"
                                margin={"dense"}
                            />
                        </Grid>
                        <Grid item xs={6}>

                        </Grid>

                        <Grid item xs={2}>
                            <Button onClick={this.getIngestionData.bind(this)}
                                    variant="contained"
                                    color="primary"
                                    className={classes.button}
                                    startIcon={<Icon>refresh</Icon>}
                            >
                                Refresh
                            </Button>
                        </Grid>


                    </Grid>

                    <ReactTable
                        filterable
                        data={this.state.ingestionData}
                        columns={this.state.columnDefs}
                        loading={this.state.loading}
                        className="-striped -highlight"
                        filtered={this.state.filtered}
                        ref={r => this.reactTable = r}
                        onFilteredChange={this.onFilteredChange.bind(this)}
                        defaultFilterMethod={(filter, row, column) => {
                            const id = filter.pivotId || filter.id;
                            if (row[id] !== null && typeof row[id] === "string") {
                                return (row[id] !== undefined
                                    ? String(row[id].toLowerCase()).includes(filter.value.toLowerCase())
                                    : true);
                            }
                        }}
                        style={{
                            height: "80vh" // This will force the table body to overflow and scroll, since there is not enough room
                        }}
                    />

                    <Grid container className={classes.toolsContainer}
                          direction="row"
                          justify="space-between"
                          alignItems="center" spacing={0}>
                        <Grid item xs={4}>
                            <Typography variant={"caption"}>Note: The date & time is shown in your local time
                                zone - {moment.tz.guess()}
                            </Typography>
                        </Grid>
                        <Grid item xs={3}>
                            <Typography variant={"caption"}>
                                This page will refresh every {this.state.refreshMinutes} minutes.
                            </Typography>
                        </Grid>
                    </Grid>
                </React.Fragment>
                }
            </React.Fragment>
        );
    }
}


StatusTable.propTypes = {
    classes: PropTypes.object.isRequired,
    theme: PropTypes.object.isRequired,
};


export default withSnackbar(withStyles(styles, {withTheme: true})(StatusTable));
